import React from 'react';
import Header from './components/Header';
import Library from './components/Library';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Library />
      </main>
    </div>
  );
}

export default App;
